import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_weekly_rest_days_provided_facility_line_legal'

export const dataPointDefinition = {
  retracedId: 'are_weekly_rest_days_provided_facility_line_legal',
  name: 'Are the weekly rest days provided by the facility in line with legal requirements?',
  description:
    'This question refers to the actual weekly rest days provided in the assessment period, which may or may not be in line with the overall facility policy in the previous question. ',
  meta: {
    slcpMeta: {
      key: 'wh-9--1',
      number: 'WH-WOR-23',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-9--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36330,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
